/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { PjErrorInfo } from '../../extends_fw/service/PjErrorInfo';
import { PjBaseService } from '../../extends_fw/service/PjBaseService';
import { PjServiceResponse } from '../../extends_fw/service/PjServiceResponse';
import { HistoryApi } from '../api/HistoryApi';
import { HistoryTimestamp } from '../model/HistoryTimestamp';
import { GetHistoryRes } from '../model/GetHistoryRes';
import { PutHistoryRes } from '../model/PutHistoryRes';
import { GetHistorytimestampRes } from '../model/GetHistorytimestampRes';

/**
 * 画面遷移の履歴を管理する。サーバへの履歴の送信、サーバからの履歴の取得を行う。
 */
export class HistoryService extends PjBaseService {

    /**
     * ステータス
     */
    protected state: string;

    /**
     * キャッシュデータ
     */
    protected data: any;

    /**
     * タイムスタンプ
     */
    protected timestamps: {[key: string ]: boolean} = {};

    /**
     * コンストラクタ
     * @param {ng.IQService} $q 非同期サービス
     * @param {HistoryApi} historyApi 履歴管理Api
     */
    /* @ngInject */
    public constructor(
            protected $q: ng.IQService,
            protected historyApi: HistoryApi) {
        super(null);

        // 初回読み込み時にサーバ側のステータスを取得する必要あり
        if (!this.state) {
            this.historyApi.historyGet(true)
                .success((res: GetHistoryRes, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                    this.state = res.state;
                    for (let i: number = 0; i < res.timestamps.length; i++) {
                       this.timestamps[res.timestamps[i].timstamp] = true;
                    }
            })
            .error((data: PjErrorInfo, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                this.noticeStartupError(status);
            });

        }
    }

    /**
     * 履歴送信
     * @param {string} timestamp タイムスタンプ
     * @param {any} data 履歴データ
     */
    public addHistory(
            timestamp: string,
            data: any): void {

        // タイムスタンプを保持する
        this.timestamps[timestamp] = true;

        // サーバへ送信
        this.historyApi.historyPut(timestamp, JSON.stringify(data), true)
            .success((res: PutHistoryRes, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {

            })
            .error((dataErr: PjErrorInfo, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {

            });
    }

    /**
     * 履歴取得
     * @param {string} state ステータス
     * @return {ng.IPromise<PjServiceResponse<string>>} 通信結果のPromiseを返す。Promiseに渡されるデータは、履歴データとなる。
     */
    public getHistory(
            state: string): ng.IPromise<PjServiceResponse<string>> {
        let deferred: ng.IDeferred<PjServiceResponse<string>> = this.$q.defer();
        if (this.state !== state) {
            this.historyApi.historyTimestampGet(state, true)
                .success((res: GetHistorytimestampRes, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                    this.state = state;
                    this.data = res.data;
                    deferred.resolve({ status: status, data: JSON.parse(res.data) });
            })
            .error((data: PjErrorInfo, status: number, headers: ng.IHttpHeadersGetter, config: ng.IRequestConfig) => {
                deferred.reject({ status: status, error: data });
            });
        } else {
            deferred.resolve({status : 200, data : this.data});
        }
        return deferred.promise;
    }

    /**
     * タイムスタンプチェック
     * @param {string} timestamp タイムスタンプ
     * @return {boolean} タイムスタンプがある場合：true, タイムスタンプがない場合：false
     */
    public contains(
            timestamp: string): boolean {
        if (this.timestamps[timestamp]) {
           return true;
        }
        return false;
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/history/service/HistoryService.ts
 **/